/** The tabs of the page of a PO in Backstage, in the order it shows them: the sync to Business Central is Tomorrow's. */
export const purchaseOrderTabs = ["lines", "changes", "details", "revisions", "sync", "history"] as const;
export type PurchaseOrderTab = (typeof purchaseOrderTabs)[number];
